import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const SITE_NAME = "El Noticiero";

export const api = axios.create({ baseURL: `${BACKEND_URL}/api`, withCredentials: true });

export const imgUrl = (url) => (!url ? null : url.startsWith("/api/") ? `${BACKEND_URL}${url}` : url);

export const errMsg = (e) => {
  const detail = e?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    const field = detail[0]?.loc?.slice(-1)[0];
    return field ? `Revisa el campo «${String(field).replace(/_/g, " ")}»: valor no válido` : "Revisa los campos del formulario";
  }
  return e?.message || "Algo salió mal";
};

export const get = (url, params) => api.get(url, { params }).then((r) => r.data);
